import {
  ON_HOLD_PROVIDER,
  ON_HOLD_PROVIDER_FAILURE,
  ON_HOLD_PROVIDER_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const onHoldProviderReducer = (state = initialState, action) => {
  switch (action.type) {
    case ON_HOLD_PROVIDER:
      return { ...state, loading: true };
    case ON_HOLD_PROVIDER_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case ON_HOLD_PROVIDER_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default onHoldProviderReducer;
